import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'commentTypeBadge' })
export class CommentTypeBadgePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'UPLOAD':
        return 'bg-upload';
      case 'REQUEST_ACTIVE_CHANGE':
        return 'bg-active-change';
      case 'APPROVE_DOCUMENT':
        return 'bg-approve';
      case 'REJECT_DOCUMENT':
        return 'bg-reject';
      default:
        return '';
    }
  }
}